import React from 'react';

const BusinessPage = React.lazy(() => import('pages/Business/BusinessPage'));
const BusinessAddPage = React.lazy(() => import('pages/Business/BusinessAddPage'));

const businessRoutes = [
  {
    path: '/business',
    exact: true,
    name: 'Danh sách bệnh viện ',
    function: 'AM_BUSINESS_VIEW',
    component: BusinessPage,
  },
  {
    path: '/business/add',
    exact: true,
    name: 'Thêm mới bệnh viện',
    function: 'AM_BUSINESS_ADD',
    component: BusinessAddPage,
  },
  {
    path: '/business/detail/:business_id',
    exact: true,
    name: 'Chi tiết bệnh viện',
    function: 'AM_BUSINESS_VIEW',
    component: BusinessAddPage,
  },
  {
    path: '/business/edit/:business_id',
    exact: true,
    name: 'Chỉnh sửa bệnh viện',
    function: 'AM_BUSINESS_EDIT',
    component: BusinessAddPage,
  },
];

export default businessRoutes;
